import { render, staticRenderFns } from "./InnovationBalance.vue?vue&type=template&id=47fc4a79&scoped=true&"
import script from "./InnovationBalance.vue?vue&type=script&lang=js&"
export * from "./InnovationBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc4a79",
  null
  
)

export default component.exports